import { Component, ViewChild } from '@angular/core';
import { PaginatorFetcher, PaginatorFilters, TableComponent, TableConfig } from '@michelin/theme';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';
import { UserDto, UserSimpleDto } from 'src/app/shared/models/user/user-dto';
import { UserService } from 'src/app/shared/services/user/user.service';

@Component({
    selector: 'app-list-user',
    templateUrl: './list-user.component.html',
    standalone: false
})
export class ListUserComponent {
  tableConfig: TableConfig<UserSimpleDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      name: { header: 'Nome', sortable: true, cell: (item) => item.name },
      email: { header: 'E-mail', sortable: true, cell: (item) => item.userId },
      userProfile: { header: 'Perfil de Acesso', sortable: true, cell: (item) => item.userProfile },
      enabled: { header: 'Ativo', sortable: true, cell: 'activeCell' },
      actions: { cell: 'actionsCell', width: '100px', header: ' ' }
    }
  };

  filterForm: FormGroup = this.form.group({
    name: this.form.control('', { nonNullable: true }),
    email: this.form.control('', { nonNullable: true }),
    userType: this.form.control('', { nonNullable: true }),
    companyName: this.form.control('', { nonNullable: true }),
    enabled: this.form.control('', { nonNullable: true })
  });

  fetcher: PaginatorFetcher<UserSimpleDto> = (filters: PaginatorFilters) => this.userService.search(filters);

  @ViewChild(TableComponent, { static: true }) table: TableComponent<UserSimpleDto>;

  constructor(private router: Router, private form: FormBuilder, private userService: UserService) {}

  get filterValues(): any {
    return this.filterForm.value;
  }

  applyFilter() {
    this.table.patchExtraFilters(this.filterValues, true);
  }

  resetFilter() {
    this.filterForm.reset();
    this.table.patchExtraFilters(this.filterValues, true);
  }

  redirectToEdit(item: UserSimpleDto) {
    this.router.navigate([`/users/${item.id}/update`]);
  }
}
